import { render, staticRenderFns } from "./DesktopMiniFooter.vue?vue&type=template&id=1f8f7f91&scoped=true"
import script from "./DesktopMiniFooter.vue?vue&type=script&lang=js"
export * from "./DesktopMiniFooter.vue?vue&type=script&lang=js"
import style0 from "./DesktopMiniFooter.vue?vue&type=style&index=0&id=1f8f7f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f7f91",
  null
  
)

export default component.exports